import { currentLanguage } from '../currentLanguage';
import './Pill.scss';
const Pill = ({ label = currentLanguage.New }: { label?: string }) => {
  return <div className="pill">{label}</div>;
};

export default Pill;
